export default __webpack_public_path__ + "static/media/aprimorar_item_02.dca68e65.mp3";